/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_SkillsInputs */

const de_language_skills = /** @type {(inputs: Language_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachkenntnisse`)
};

/** @type {(inputs: Language_SkillsInputs) => LocalizedString} */
const en_language_skills = () => /** @type {LocalizedString} */ ('language_skills')

/**

* @param {Language_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const language_skills = /** @type {((inputs?: Language_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_language_skills(inputs)
	return en_language_skills(inputs)
});